import { styled } from 'styled-components';

import { theme } from '../../styles';
import { CircleInfoIcon, TriangleExclamationIcon } from '../../assets/icons';
import { Headings } from '../Headings';
import { Container, Flex, ResponsiveSpacer, Spacer } from '../Layout';
import { Link } from '../Link';
import { useMediaMin } from '../Media';
import { Text } from '../Text';

const StyledBanner = styled(Container)<{ variant: string }>`
  ${props => props.variant === 'warning' && `background-color: ${theme.colors.babyYellow};`}
  ${props => props.variant === 'danger' && `background-color: ${theme.colors.babyPink};`}
  overflow: hidden;
`;

type BannerProps = {
  /** Title text for the `<Banner/>`*/
  title: string;
  /** Subtitle text for the `<Banner/>`*/
  subtitle: string;
  /** Changes the background color and icon of the `<Banner/>` */
  variant: 'warning' | 'danger';
  /** Display icon boolean */
  hasIcon?: boolean;
  link?: string;
  linkText?: string;
};

export const Banner = ({ title, subtitle, variant, link, linkText, hasIcon = true }: BannerProps) => {
  const isTablet = useMediaMin(theme.breakpoint.md);
  return (
    <StyledBanner variant={variant}>
      <Flex
        maxWidth={660}
        height={['auto', 210, 210]}
        paddingLeft={[20, 0, 0]}
        paddingRight={[20, 0, 0]}
        paddingTop={[30, 0, 0]}
        paddingBottom={[30, 0, 0]}
        marginLeft="auto"
        marginRight="auto"
        flexDirection="column"
        justifyContent="center"
      >
        <ResponsiveSpacer marginLeft={[0, 10, 10]} gutterHeight={5} breakpoint={theme.breakpoint.md}>
          {hasIcon && variant === 'warning' && <TriangleExclamationIcon width={22} marginRight={10} />}
          {hasIcon && variant === 'danger' && <CircleInfoIcon width={22} marginRight={10} />}
          <Headings.H3>{title}</Headings.H3>
        </ResponsiveSpacer>
        <Spacer marginLeft={isTablet && hasIcon ? 42 : 0}>
          <Text size="medium" marginTop={5} marginBottom={5}>
            {subtitle}
            {link && (
              <Link fontSize="medium" testId="banner-link-testid" to={link}>
                {linkText ?? link}
              </Link>
            )}
          </Text>
        </Spacer>
      </Flex>
    </StyledBanner>
  );
};
